export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9653.8bf1616b.jpg";